import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { formatAddress, formatDistance, removeVenueFromList, listContainVenue, calculateDistance } from "../utilities/utilities";
import { SECTION_COLOR } from "../constants";
import { WHITE_COLOR, LocalStorage } from "../constants";
import { Venue } from "../types/nearby";
import { SavedPlace } from "../types/savedplace";
import {
  makeAndHandleResultsRequestById,
  makeAndHandleSimilarVenueRequest,
  makeAndHandleNearbyVenueRequest
} from "../utilities/serviceCalls";
import { useHistory, useLocation } from "react-router-dom";
import { usePlaceState } from "../store/place/placeContext";
import { useResultsState } from "../store/results/resultsContext";
import HeartCheckBox from "./HeartCheckBox";
import Lockr from "lockr";
import { SavedPlacesContext } from "../contexts";
import { SubscribedPlacesContext, AlertsConfigContext } from "../contexts";
import { crowdAnalytics2saved } from "../utilities/convertVenues";
import close from "../assets/images/close.svg";
import { makeAndHandleDeleteAlert } from '../utilities/serviceCalls'
import db from '../firebase';
import {   unsubscribreVenue } from "../utilities/alertsConfig";

function SubscribedCard(props: {
  user: any,
  venue: SavedPlace;
  origin: {
    lat: number,
    lng: number
  };
  className?: string;
}) {
  const { venue, origin } = props;
  const history = useHistory();
  const location = useLocation();
  // Global State
  const { dispatchPlaceState } = usePlaceState();
  const { dispatchResultsState } = useResultsState();
  const [savedPlaces, setSavedPlaces] = React.useContext(SavedPlacesContext)
  const [subscribedPlaces, setSubscribedPlaces] = React.useContext(  SubscribedPlacesContext)
  const [favorite, setFavorite] = useState(false)
  const [ configState, setConfigState ] = React.useContext(AlertsConfigContext)

  useEffect(() => setFavorite(listContainVenue(savedPlaces, venue)))

  const executeResultsEstimation = async (venue: SavedPlace): Promise<void> => {
    let results;

    // Check if selectedVenue ID is an Address and handle appropriate results request
    results = await makeAndHandleResultsRequestById(venue.id);

    dispatchResultsState({
      type: "SET_VENUES",
      payload: results,
    });
    // replace selected venue
    dispatchPlaceState({
      type: "SET_SELECTED_VENUE",
      payload: results.venue,
    });

    // if (location.pathname === "/results" || "/savedPlaces") {
    history.push("/venue_details?venueId=" + results.venue.id +
      '&name=' + results.venue.name +
      '&lat=' + results.venue.location.lat +
      '&lng=' + results.venue.location.lng +
      '&query=' + results.venue.name
    );
    // }
  }

  const onHeartCheck = (event: any) => {
    event.stopPropagation()
    if (favorite) {
      const savedPlaces = Lockr.smembers(LocalStorage.SAVEDPLACES)
      const newSavedPlaces = removeVenueFromList(savedPlaces, venue)
      Lockr.set(LocalStorage.SAVEDPLACES, newSavedPlaces)
      setSavedPlaces(newSavedPlaces) // Update global state
    } else {
      Lockr.sadd(LocalStorage.SAVEDPLACES, venue)
      const newSavedPlaces = Lockr.smembers(LocalStorage.SAVEDPLACES)
      setSavedPlaces(newSavedPlaces) // Update global state
    }
    setFavorite(favorite ? false : true)
  }

  const onUnSubscribe = async (event: any) => {

      event.stopPropagation()
      const newSubscribedPlaces = await unsubscribreVenue(venue, props.user, configState.sync)
      setSubscribedPlaces(newSubscribedPlaces)

  } 

  let distance = formatDistance(calculateDistance(origin, venue.location))
  // let imgSrc = venue.categories[0].icon.prefix
  return (
    <Card className={props.className} onClick={() => executeResultsEstimation(venue)}
      style={{ borderRadius: '0px', background: SECTION_COLOR, color: WHITE_COLOR }}>
      <Card.Body style={{ padding: '0px' }}>
        <Row>
          <Col xs={2}>
            <div style={{ margin: 'auto', width: '50px' }}>
              <img src={venue.icon}
                alt="" width='50px' height='50px' />
            </div>
          </Col>
          <Col xs={5} >
            <div>{venue.name}</div>
            <div style={{ fontSize: '10px', position: 'absolute', bottom: '0px' }}>{formatAddress(venue)}</div>
          </Col>
          
            <Col xs={4} >
              <div style={{ textAlign: 'right' }}>{distance}</div>
              <div style={{ textAlign: 'right'}}><HeartCheckBox checked={favorite} onClick={onHeartCheck} /></div>
              
            </Col>
            <Col  xs={1} style={{top:-10}}  > 
              <img src={close} alt='Delete from subscribed' onClick={onUnSubscribe}></img>
            </Col>
         
        </Row>
      </Card.Body>
    </Card>
  );
}

export default SubscribedCard;
